export default {
    size: {
        type: String,
        validator(value) {
            ["xs", "md-450", "md", "lg", "xl"].includes(value);
        },
        default: "md",
    },
    type: {
        type: String,
        validator(value) {
            ["rounded", "sm-round", "square"].includes(value);
        },
        default: "rounded",
    },
    hasHeader: {
        type: Boolean,
        default: false,
    },
    hasFooter: {
        type: Boolean,
        default: false,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    canClose: {
        type: Boolean,
        default: true,
    },
    canClickOutsideClose: {
        type: Boolean,
        default: true,
    },
    saving: {
        type: Boolean,
        default: false,
    },
    headerAlign: {
        type: String,
        validator(value) {
            return ["start", "center", "end", "between"].includes(value);
        },
        default: null,
    },
    footerAlign: {
        type: String,
        validator(value) {
            return ["start", "center", "end", "between"].includes(value);
        },
        default: null,
    },
    headerDense: {
        type: Boolean,
        default: false,
    },
    footerDense: {
        type: Boolean,
        default: false,
    },
};
